import { render, staticRenderFns } from "./AboutExpandable.vue?vue&type=template&id=0a87f869"
import script from "./AboutExpandable.vue?vue&type=script&lang=js"
export * from "./AboutExpandable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports